// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v5-countdown{padding:.4rem 0;text-align:center}.v5-countdown .v5-countdown-num{position:relative;overflow:hidden;display:inline-block;width:.6666666667rem;height:.7333333333rem;border-radius:.0666666667rem;color:currentColor;vertical-align:middle}.v5-countdown .v5-countdown-colon{font-size:.3733333333rem;font-weight:600;color:#666}", ""]);
// Exports
module.exports = exports;
